import * as angular from "angular";
import {IController} from "angular";

export class AgentsPaymentTransactionsTableCtrl implements IController {

  infiniteScroll: any;
  currencySymbol: any;

  onAddTransaction: Function;

  $onInit() {
  }
}

angular
  .module('bringoz.admin.agents')
  .component('agentsPaymentTransactionsTable', {
    bindings: {
      infiniteScroll: '<',
      currencySymbol: '<',
      onAddTransaction: '&'
    },
    template: require('./agents-payment-transactions-table.html').default,
    controller: AgentsPaymentTransactionsTableCtrl
  });
